<script setup>

import {MapboxGeolocateControl, MapboxImages, MapboxMap, MapboxNavigationControl, MapboxMarker} from "@studiometa/vue-mapbox-gl";
import {computed, ref} from "vue";

const props = defineProps({
  value: String,
  name: String,
})

const accessToken = 'pk.eyJ1Ijoic2VwdGVtYmVyZGlnaXRhbCIsImEiOiJjbDM5NTMxaWcwNmVqM2RxbTgwYTZwc2R6In0.muheCHZVNeU2x8FHymhtuQ';
const mapStyle = 'mapbox://styles/mapbox/streets-v11?optimize=true';
const zoom = ref(7);
const center = ref({lat: 52, lng: 5});

const value = ref(props.value);

const setValue = ({lngLat}) => {
  value.value = JSON.stringify([lngLat.lng, lngLat.lat]);
}

const lngLat = computed(() => {
  if(value.value){
    return JSON.parse(value.value);
  }
  return null;
})

setTimeout(() => {
  if(lngLat.value){
    const _lngLat = lngLat.value;
    console.log({_lngLat});
    zoom.value = 14;
    center.value = { lng: _lngLat[0], lat: _lngLat[1]};
  }
}, 100);

</script>

<template>
  <div
    style="
      width: 500px;
      height: 500px;
    ">
    <MapboxMap
      style="
        width: 100%;
        height: 100%;
        border-radius: 7px;
        border: solid 1px #dadde2;
        overflow: hidden;
      "
      :accessToken="accessToken"
      :mapStyle.sync="mapStyle"
      :scrollZoom="false"
      :dragRotate="false"
      :zoom.sync="zoom"
      :center.sync="center"
      @mb-click="setValue"
      ref="map"
    >
      <MapboxImages :sources="[
          {
            src: '/app/themes/natuur-en-milieu/dist/images/marker_generic.png',
            id: 'marker-generic',
          },
        ]">

      </MapboxImages>

      <MapboxNavigationControl
        position="top-right"
        :showCompass="false"
      />
      <MapboxGeolocateControl
        :trackUserLocation="true"
        :positionOptions="{enableHighAccuracy: true}"
        ref="tracker"
      />
      <MapboxMarker v-if="lngLat" :lngLat="lngLat" />
    </MapboxMap>
    <input type="hidden" v-model="value" :name="props.name" />
  </div>
</template>

<style scoped>

</style>